import { render, staticRenderFns } from "./ProfilePageAuth.vue?vue&type=template&id=7b8181d7&"
import script from "./ProfilePageAuth.vue?vue&type=script&lang=js&"
export * from "./ProfilePageAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports